module.exports = __webpack_public_path__ + "static/media/DS.6c022004.png";